<div class="dialog-wrapper bg-default-950 p-4 pt-2 text-inverse-color">
  <div class="close-button text-end">
    <button (click)="closeDialog()" class="mobile-button" aria-label="Close Dialog" title="Close Dialog">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>
  @if (this.dialogData.segmentItem) {
    <tall-track-card [item]="this.dialogData.segmentItem" [eventSource]="null"></tall-track-card>
  }
</div>
